var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('NavBar',{attrs:{"title":_vm.$t('main.scanqr')}}),_c('QRScanner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }